/* eslint-disable react/prop-types */
import React, { useState, useEffect, memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {
  Text,
  LoadingDot,
  Table,
} from 'components/atoms';
import { PopoverActions, PageState } from 'components/molecules'
import { UsersAvatarList } from 'containers'
import { generateEditorPath, computeDateDistance } from 'services/generators';
import { injectIntl, FormattedMessage } from 'react-intl'
import { intlType } from 'types'

const PageTable = memo(({
  subweb,
  pages,
  loading,
  intl,
  noDataText,
  // eslint-disable-next-line no-unused-vars
  handlePageArchive,
  handlePageEdit,
  isLoadingActions,
}) => {
  const [data, setData] = useState([])
  useEffect(() => {
    if (!loading) setData([...pages])
  }, [pages, loading])

  return (
    <Table
      data={data}
      columns={[
        {
          Header: intl.formatMessage({ id: 'page' }),
          accessor: 'title',
          Cell: ({ value, original: { id: pageId } }) => (
            <Table.CellLink to={generateEditorPath({ pageId, subweb })}>
              <Cell value={value} loadingDots={loading} />
            </Table.CellLink>
          ),
        },
        {
          Header: intl.formatMessage({ id: 'table.title.last' }),
          accessor: 'updatedAt',
          Cell: ({ value, original: { id: pageId } }) => (
            <Table.CellLink to={generateEditorPath({ pageId, subweb })}>
              <Cell value={`há ${computeDateDistance(value)}`} loading={loading} />
            </Table.CellLink>
          )
        },
        {
          Header: intl.formatMessage({ id: 'editors' }),
          accessor: 'contributors',
          Cell: ({ value, original: { id: pageId } }) => (
            <Table.CellLink to={generateEditorPath({ pageId, subweb })}>
              <UsersAvatarList users={value} loading={loading} />
            </Table.CellLink>
          ),
        },
        {
          Header: intl.formatMessage({ id: 'status' }),
          accessor: 'state',
          Cell: ({ value, original: { id: pageId } }) => {
            let langLinks = []
            if (value && value.length > 0) {
              langLinks = value.map(
                ({ label }) => (
                  { langKey: label, link: generateEditorPath({ pageId, subweb, lang: label }) }
                )
              )
            }
            return (
              <Table.CellLink to={generateEditorPath({ pageId, subweb })}>
                <PageState langLinks={langLinks} stateItems={value} />
              </Table.CellLink>

            )
          },
        },
        {
          Header: '',
          accessor: 'actions',
          Cell: ({ original: { id: pageId } }) => (
            <Table.CellLink to={generateEditorPath({ pageId, subweb })}>
              <CellEnd>
                <PopoverActions
                  disabled={loading}
                  actions={[
                    {
                      text: intl.formatMessage({ id: 'edit' }),
                      onClick: () => handlePageEdit({ subweb, pageId }),
                      icon: 'edit',
                      isLoading: isLoadingActions,
                    },
                    // {
                    //   text: intl.formatMessage({ id: 'archive' }),
                    //   onClick: () => handlePageArchive({ subweb, pageId }),
                    //   icon: 'fal fa-eye-slash',
                    //   isLoading: isLoadingActions,
                    // },
                  ]}
                  position="bottom"
                  align="start"
                  handlerWidth={72}
                />
              </CellEnd>
            </Table.CellLink>
          ),
        },
      ]}
      defaultPageSize={10}
      minRows={0}
      className="-striped -highlight"
      noDataText={noDataText || 'Não foram encontradas subwebs'}
      sortable={false}
      showPagination={false}
      loading={loading}
      loadingText="A carregar..."
      clearRowPadding
    />
  );
});

const Cell = ({ value, loadingDots, loading }) => {
  if (loadingDots) return <LoadingDot />
  if (loading) return <LoadingCell />
  if (!value) {
    return (
      <Text modifiers={['lighter']}>
        <FormattedMessage id="error.missing" />
      </Text>
    )
  }
  return <Text modifiers={['light']}>{value}</Text>
};

const LoadingCell = styled.div`
  width: 80px;
  background-color: ${props => props.theme.colors.bgLighterS};
`

const CellEnd = styled.div`
  justify-content: flex-end;
  width: 100%;
  display: flex;
`

PageTable.propTypes = {
  pages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string,
      lastUpdated: PropTypes.string,
      slug: PropTypes.string,
      state: PropTypes.arrayOf(PropTypes.shape({})),
    })
  ),
  loading: PropTypes.bool,
  intl: intlType.isRequired,
  noDataText: PropTypes.string,
  handlePageArchive: PropTypes.func,
  handlePageEdit: PropTypes.func,
  subweb: PropTypes.string.isRequired,
  isLoadingActions: PropTypes.bool,
};

PageTable.defaultProps = {
  pages: [],
  loading: true,
  noDataText: null,
  handlePageArchive: () => {},
  handlePageEdit: () => { },
  isLoadingActions: false,
}


export default injectIntl(PageTable);
